import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchRemoveServices } from "../../../../redux/slices/services";
import Alert from "../components/Alert";
import Notification from "../components/Notification";

export default function Service({ service }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  const handleEdit = () => {
    navigate("/admin/edit-service", { state: service });
  };

  const deleteService = () => {
    dispatch(fetchRemoveServices(service._id));
    setShow(true);
    setTimeout(() => setShow(false), 3500);
  };

  return (
    <>
      <Alert
        open={open}
        setOpen={setOpen}
        text={"Удалить услугу?"}
        subText={"Вы уверены? Действие нельзя будет отменить."}
        btnText={"Удалить"}
        deleteClicked={deleteService}
      />
      <div className="group relative w-[280px] min-h-[360px] rounded-xl border border-neutral-200 shadow-lg flex flex-col">
        <div className="relative w-full h-44 rounded-tl-lg rounded-tr-lg overflow-hidden bg-neutral-100">
          {service.imageUrl ? (
            <img
              src={`${process.env.REACT_APP_BASE_API}${service.imageUrl}`}
              alt=""
              className="w-full h-full object-center object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-neutral-400 text-sm">
              Нет фото
            </div>
          )}
        </div>
        <div className="mt-3 px-4 flex-1">
          <h3 className="text-lg font-medium text-neutral-900 capitalize truncate">
            {service.name?.ru || service.name?.en}
          </h3>
          <p className="text-sm text-neutral-500 truncate">{service.name?.en}</p>
          <p className="line-clamp-3 text-sm mt-2 text-neutral-600">
            {service.description?.ru || service.description?.en}
          </p>
          <p className="text-sm font-semibold text-neutral-900 mt-2">
            {service.price}
          </p>
        </div>
        <div className="w-full flex items-center justify-between my-4 px-4">
          <button onClick={handleEdit} type="button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 cursor-pointer text-neutral-900 hover:text-neutral-600"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
              />
            </svg>
          </button>
          <button onClick={() => setOpen(true)} type="button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 cursor-pointer text-red-600 hover:text-red-400"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
              />
            </svg>
          </button>
        </div>
      </div>
      <Notification
        show={show}
        setShow={setShow}
        text={"Услуга удалена!"}
        state={"success"}
      />
    </>
  );
}
